import { NotificationTypes } from "~enums/notificationTypes.ts";
import { DefaultNotificationItem } from "~pages/Notifications/components/DefaultNotificationItem.tsx";
import { ExportNotificationItem } from "~pages/Notifications/components/ExportNotificationItem.tsx";
import { ImportNotificationItem } from "~pages/Notifications/components/ImportNotificationItem/ImportNotificationItem.tsx";
import { PermissionChangeNotificationItem } from "~pages/Notifications/components/PermissionChangeNotificationItem.tsx";
import { ReportNotificationItem } from "~pages/Notifications/components/ReportNotificationItem.tsx";
import type { Notification } from "~types/notification.ts";

type Props = {
  notification: Notification;
};

const NotificationItem = ({ notification }: Props) => {
  switch (notification.type) {
    case NotificationTypes.Export:
      return <ExportNotificationItem notification={notification} />;
    case NotificationTypes.Import:
      return <ImportNotificationItem notification={notification} />;
    case NotificationTypes.Report:
      return <ReportNotificationItem notification={notification} />;
    case NotificationTypes.PermissionChange:
      return <PermissionChangeNotificationItem notification={notification} />;
    default:
      return <DefaultNotificationItem notification={notification} />;
  }
};

export default NotificationItem;
